import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"

import { withSubscriptions } from "hocs/features"
import Subscription from "components/Subscriptions/Item"
import { SubscriptionListType, SubscriptionType } from "types"

type Props = {
  subscriptions: SubscriptionListType
  total: number
}

const List = ({ subscriptions, total }: Props) => {
  const { t } = useTranslation()

  const isEmpty = total === 0

  return (
    <Container data-testid="subscriptions-list">
      {isEmpty ? (
        <Typography component="span" variant="subtitle1">
          {t("pages.subscription.empty.title")}
        </Typography>
      ) : (
        <>
          {subscriptions.map((item: SubscriptionType) => (
            <Subscription key={item.id} item={item} />
          ))}
        </>
      )}
    </Container>
  )
}

export default compose<ComponentType>(withSubscriptions)(List)

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  margin: "42px 0 8px 0",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
    flexDirection: "column",
  },
}))
